/**
 * Shim for `@react-native-community/netinfo` using the browser online/offline
 * events and the Network Information API where available.
 */
type NetInfoState = {
  isConnected: boolean;
  isInternetReachable: boolean | null;
  type: string;
  details: any;
};

function currentState(): NetInfoState {
  const online = typeof navigator !== 'undefined' ? navigator.onLine : true;
  return {
    isConnected: online,
    isInternetReachable: online,
    type: online ? 'unknown' : 'none',
    details: (navigator as any).connection ?? null,
  };
}

const listeners = new Set<(state: NetInfoState) => void>();

if (typeof window !== 'undefined') {
  const notify = () => {
    const state = currentState();
    listeners.forEach((l) => l(state));
  };
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
}

const NetInfo = {
  addEventListener(listener: (state: NetInfoState) => void) {
    listeners.add(listener);
    listener(currentState());
    return () => listeners.delete(listener);
  },
  async fetch(): Promise<NetInfoState> {
    return currentState();
  },
  useNetInfo: () => currentState(),
};

export default NetInfo;
